import { motion } from "framer-motion";

// Fade-up scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Overline label with gold small caps
export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-sans-ui text-[11px] md:text-xs uppercase tracking-[0.35em] text-gold ${className}`}
  >
    {children}
  </span>
);
